import { FC } from 'react'
import { BadgeName } from 'src/app/types'
import { BADGE_SVG_URL_MAP } from 'src/constant'

type BadgeSVGProps = {
  name: BadgeName
  styles?: string
}

const BadgeSVG: FC<BadgeSVGProps> = ({ name, styles }) => {
  const imgSrc = BADGE_SVG_URL_MAP[name]
  const needsVerticalNudgeDown = ['medal', 'ribbon'].includes(name)
  const verticalNudgeClass = needsVerticalNudgeDown ? 'translate-y-0.5' : ''

  return (
    <img
      data-id="add-badge"
      width="17"
      height="18"
      alt={name}
      src={imgSrc}
      className={`${verticalNudgeClass} ${styles}`}
    />
  )
}

export default BadgeSVG
